var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row } from "react-bootstrap";
import CardImage from "@irati/ui/src/Layout/CardImage";
import Link from "@irati/ui/src/Link";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H1 } from "@irati/ui/src/Typography";
import iconLaunch from "@irati/ui/images/launch.svg";
import billing from "@irati/ui/images/billing.svg";
import training from "@irati/ui/images/training.svg";
import customisation from "@irati/ui/images/customisation.svg";
import peoplemgt from "@irati/ui/images/peoplemgt.svg";
import tracking from "@irati-tracking/admin";
import HelpTrackingKeys from "../../constants/HelpTrackingKeys";
var cards = [
    {
        href: "admin.containers.help.webinars.href",
        imageSrc: training,
        imageAlt: "admin.containers.help.card.webinars.alt",
        title: "admin.containers.help.card.webinars.title",
        description: "admin.containers.help.card.webinars.description",
        trackingKey: HelpTrackingKeys.trainingWebinars
    },
    {
        href: "admin.containers.help.launching.href",
        imageSrc: iconLaunch,
        imageAlt: "admin.containers.help.card.launching.alt",
        title: "admin.containers.help.card.launching.title",
        description: "admin.containers.help.card.launching.description",
        trackingKey: HelpTrackingKeys.launching
    },
    {
        href: "admin.containers.help.customisation.href",
        imageSrc: customisation,
        imageAlt: "admin.containers.help.card.customisation.alt",
        title: "admin.containers.help.card.customisation.title",
        description: "admin.containers.help.card.customisation.description",
        trackingKey: HelpTrackingKeys.customisation
    },
    {
        href: "admin.containers.help.management.href",
        imageSrc: peoplemgt,
        imageAlt: "admin.containers.help.card.management.alt",
        title: "admin.containers.help.card.management.title",
        description: "admin.containers.help.card.management.description",
        trackingKey: HelpTrackingKeys.peopleManagement
    },
    {
        href: "admin.containers.help.payments.href",
        imageSrc: billing,
        imageAlt: "admin.containers.help.card.payments.alt",
        title: "admin.containers.help.card.payments.title",
        description: "admin.containers.help.card.payments.description",
        trackingKey: HelpTrackingKeys.billingPayments
    }
];
var Help = /** @class */ (function (_super) {
    __extends(Help, _super);
    function Help() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTracking = function (trackingKey) {
            switch (trackingKey) {
                case HelpTrackingKeys.trainingWebinars:
                    tracking.viewTrainingWebinars();
                    break;
                case HelpTrackingKeys.launching:
                    tracking.viewLaunchingPerkbox();
                    break;
                case HelpTrackingKeys.customisation:
                    tracking.viewCustomisation();
                    break;
                case HelpTrackingKeys.peopleManagement:
                    tracking.viewPeopleManagement();
                    break;
                case HelpTrackingKeys.billingPayments:
                    tracking.viewBillingPayments();
                    break;
            }
        };
        return _this;
    }
    Help.prototype.componentDidMount = function () {
        tracking.viewHelp();
    };
    Help.prototype.render = function () {
        var _this = this;
        var formatMessage = this.props.formatMessage;
        return (React.createElement(React.Fragment, null,
            React.createElement(H1, { marginBottom: 4 },
                React.createElement(FormattedMessage, { id: "admin.containers.help.heading.help" })),
            React.createElement(Row, null, cards.map(function (card, i) {
                return (React.createElement(Link, { href: formatMessage({ id: card.href }), onClick: function () { return _this.handleTracking(card.trackingKey); }, target: "_blank", key: "card" + i },
                    React.createElement(CardImage, { colSize: 6, imageSrc: card.imageSrc, imageAlt: formatMessage({ id: card.imageAlt }), imagePosition: "left", imageSize: 80, title: formatMessage({ id: card.title }), description: formatMessage({ id: card.description }), rollover: true })));
            }))));
    };
    return Help;
}(PureComponent));
export default injectIntl(Help);
